import router from '@/router';
import { get } from '@/utils/local';

function normalizeHospitalInfo(raw) {
    if (!raw) {
        return null;
    }
    const id = raw.id || raw.Id || raw.hospitalId || '';
    const name = raw.name || raw.Name || '';
    const admvs = raw.admvs || raw.Admvs || raw.Admdvs || '';
    const code = raw.code || raw.Code || '';
    const registerTime = raw.registerTime || raw.RegisterTime || '';
    const instLevel = raw.instLevel || raw.InstLevel || '';
    const hisLocalServiceUrl = raw.hisLocalServiceUrl || raw.HisLocalServiceUrl || '';
    const hdisApiUrl = raw.hdisApiUrl || raw.HdisApiUrl || '';
    const hdisSyncApiUrl = raw.hdisSyncApiUrl || raw.HdisSyncApiUrl || '';
    const insuplc_admdvs = raw.insuplc_admdvs || raw.Insuplc_admdvs || '';

    if (!id && !name && !admvs && !code && !registerTime && !instLevel) {
        return null;
    }

    return {
        id,
        name,
        admvs,
        code,
        registerTime,
        instLevel,
        hisLocalServiceUrl,
        hdisApiUrl,
        hdisSyncApiUrl,
        insuplc_admdvs
    };
}

export function getHospital() {
    const storedHospital = get('hospitalInfo');
    const hospital = normalizeHospitalInfo(storedHospital);
    if (!hospital) {
        const targetPath = '/login';
        if (!router.currentRoute || router.currentRoute.path !== targetPath) {
            router.push(targetPath).catch(() => {});
        }
        return null;
    }
    return hospital;
}
